<template>
  <div ref="container" class="mosaic-ctn">
    <div class="mosaic">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>
import MosaicMixin from './mosaic-mixin'
export default {
  name: 'MonitorMosaicTransition',
  mixins: [MosaicMixin],
  mounted () {
    this.initialTransformOrigin = 'left top'
    this.finalTransformOrigin = 'right bottom'
    this.scaleProperty = 'scale'
    this.stagger = 0.05
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .mosaic-ctn
    @apply fixed z-50 pin-t pin-l h-full w-full pointer-events-none

  .mosaic
    @apply w-full h-full
    display: grid
    grid-template-columns: repeat(12, 1fr)
    grid-template-rows: repeat(10, 1fr)
    @screen lg
      grid-template-columns: repeat(13, 1fr)
      grid-template-rows: repeat(8, 1fr)
    div
      @apply bg-white
      transform: scale(0)
      &:nth-child(1)
        grid-column: 1 / 3
        grid-row: 1 / 3
      &:nth-child(2)
        grid-column: 3 / 7
        grid-row: 1 / 3
      &:nth-child(3)
        grid-column: 1 / 2
        grid-row: 3 / 7
      &:nth-child(4)
        grid-column: 2 / 5
        grid-row: 3 / 5
      &:nth-child(5)
        grid-column: 2 / 4
        grid-row: 5 / 7
      &:nth-child(6)
        grid-column: 1 / 2
        grid-row: 7 / 9
      &:nth-child(7)
        grid-column: 2 / 4
        grid-row: 7 / 9
      &:nth-child(8)
        grid-column: 4 / 6
        grid-row: 8 / 9
      &:nth-child(9)
        grid-column: 4 / 6
        grid-row: 5 / 8
      &:nth-child(10)
        grid-column: 5 / 8
        grid-row: 3 / 5
      &:nth-child(11)
        grid-column: 7 / 9
        grid-row: 2 / 3
      &:nth-child(12)
        grid-column: 7 / 9
        grid-row: 1 / 2
      &:nth-child(13)
        grid-column: 9 / 12
        grid-row: 1 / 3
      &:nth-child(14)
        grid-column: 8 / 10
        grid-row: 3 / 5
      &:nth-child(15)
        grid-column: 6 / 8
        grid-row: 5 / 8
      &:nth-child(16)
        grid-column: 6 / 10
        grid-row: 8 / 9
      &:nth-child(17)
        grid-column: 8 / 10
        grid-row: 6 / 8
      &:nth-child(18)
        grid-column: 8 / 10
        grid-row: 5 / 6
      &:nth-child(19)
        grid-column: 10 / 12
        grid-row: 3 / 6
      &:nth-child(20)
        grid-column: 10 / 12
        grid-row: 6 / 9
      &:nth-child(21)
        grid-column: 12 / 14
        grid-row: 3 / 7
      &:nth-child(22)
        grid-column: 12 / 14
        grid-row: 1 / 3
      &:nth-child(23)
        grid-column: 12 / 14
        grid-row: 7 / 9
</style>
